module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('MentoringCardWrapper', {
    attrs: {
      "step": _vm.step,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var ref_data = ref.data;
        var item = ref_data.item;
        var index = ref_data.index;
        var upperIndex = ref_data.upperIndex;

        return [_c('MentoringProgramCard', _vm._b({
          attrs: {
            "index": upperIndex || index
          }
        }, 'MentoringProgramCard', item, false))]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f175f4c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/programslist/MentoringProgramsList.vue
// module id = 5181b9d366f880e060a0
// module chunks = 89